<template>
  <div class="geofence-list-item"
       @click="$emit('click')">
    <div class="item-name one-liner">
      {{ namedLocation.name }}
    </div>

    <div class="item-address one-liner">
      {{ address }}
    </div>

    <div class="dropdown-option-arrow"></div>
  </div>
</template>

<script>
  export default {
    props: {
      namedLocation: {
        type: Object,
        required: true
      }
    },

    computed: {
      address() {
        const location = this.namedLocation

        return location.address ? location.address : `${location.latitude} ${location.longitude}`
      }
    }
  }
</script>

<style lang="scss" scoped>
  .geofence-list-item {
    width: 100%;
    height: 60px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    cursor: pointer;
    padding: 0 30px;
    border-bottom: 1px solid #f2f2f2;

    .item-name {
      width: 50%;
    }

    .item-address {
      width: 50%;
      color: map-get($colors, primary);
      text-align: right;

      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 19px;
    }

    .dropdown-option-arrow {
      width: 13px;
      height: 13px;
      border-bottom: 1px solid #b9b9b9;
      border-right: 1px solid #c2b4b4;
      transform: rotate(-45deg);
    }
   }
</style>